import Button from '@/components/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/sharp-solid-svg-icons'
import classNames from 'classnames/bind'
import Image from 'next/image'
import Link from 'next/link'
import { useSyncExternalStore } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import styles from './Posts.module.scss'
let cx = classNames.bind(styles)

const emptySubscribe = () => () => {}

function Posts({ posts, id }) {
  const mounted = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )

  return (
    <section {...(id && { id })} className={styles.posts} data-cy="featured-blog-posts-section">
      <div className={styles.headingSection} data-aos="fade-up">
        <div className={styles.headingSectionOne}>
          <p className={styles.eyebrowText}>STAY UP TO DATE</p>
          <h2 className={styles.heading} data-cy="featured-blog-posts-title">
            The latest from Integrity
          </h2>
        </div>
        <div className={styles.headingSectionTwo}>
          <Button href="/blog">
            View All posts <FontAwesomeIcon icon={faArrowRight} />
          </Button>
        </div>
      </div>

      <div className={styles.sliderContainer} data-aos="fade-up">
        {mounted && (
          <Swiper
            navigation={{ prevEl: '.prev-btn', nextEl: '.next-btn' }}
            slidesPerView={1}
            spaceBetween={30}
            loop={true}
            speed={600}
            modules={[Navigation]}
            breakpoints={{
              767: {
                slidesPerView: 2
              },
              1024: {
                slidesPerView: 3
              }
            }}
          >
            {posts?.map((post) => {
              const imageUrl = post?.postFields?.blogSliderImage?.node?.sourceUrl || post?.featuredImage?.node?.sourceUrl
              const imageAlt = post?.postFields?.blogSliderImage?.node?.altText || post?.featuredImage?.node?.altText || post.title
              return (
                <SwiperSlide key={post.id ?? ''}>
                  <Link href={post?.uri ?? '#'} data-cy="featured-blog-post-item">
                    <div className={cx('card')}>
                      <div className={cx('image-holder')}>
                        {imageUrl && (
                          <Image
                            src={imageUrl}
                            alt={imageAlt}
                            className={cx('image')}
                            width={540}
                            height={340}
                            sizes="(max-width: 767px) 100vw, (max-width: 1024px) 50vw, 33vw"
                            data-cy="featured-blog-post-item-image"
                          />
                        )}
                      </div>

                      <div className={styles.headingInfo}>
                        <div>
                          {post.categories?.nodes?.map((category, index) => (
                            <span key={index} className="eyebrow-text" data-cy="featured-blog-post-item-category">
                              {category.name}
                            </span>
                          ))}
                        </div>
                        <h3 className={cx('header', styles.headingTitle)} data-cy="featured-blog-post-item-title">
                          {post.title}
                        </h3>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              )
            })}
          </Swiper>
        )}

        <div className="prev-btn">
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div className="next-btn">
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    </section>
  )
}

export default Posts
